<template>
  <div class="c-config-content">
    <h5>{{ $t('senderList') }}</h5>
    <div v-if="firstLoading">
      <skeleton-loading>
        <row>
          <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
        </row>
        <row>
          <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
        </row>
      </skeleton-loading>
    </div>
    <div v-else>
      <div class="c-template-table table-responsive c-role-table">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>{{ $t('email') }}</th>
            <th>{{ $t('status') }}</th>
            <th>{{ $t('time') }}</th>
            <th class="text-right">
              <span @click="create" class="btn-add" v-b-tooltip.hover.top="$t('create')">
                <i class="icon16-plus-circle-gadient"></i></span>
            </th>
          </tr>
          </thead>
          <tbody v-if="listLoading" class="text-center text-primary">
          <tr>
            <th colspan="4">
              <b-spinner></b-spinner>
            </th>
          </tr>
          </tbody>
          <tbody v-if="!listLoading && !itemCount" class="text-center">
          <tr>
            <th colspan="4">
              {{ $t('noSenderFound') }}
            </th>
          </tr>
          </tbody>
          <tbody v-if="!listLoading && itemCount">
          <tr v-for="item in items" :key="item._id">
            <td>
              <p>{{ item.email }}</p>
              <p v-if="item.user">
                <span class="small text-gray-999">{{$t('createdBy')}}: </span>
                <span class="small">{{item.user.name}} ({{item.user.ext}})</span>
              </p>
            </td>
            <td>
              <label v-if="item.denyTime" class="badge badge-danger">{{ $t('denied') }}</label>
              <label v-else-if="item.confirmTime"
                     class="badge badge-success">{{ $t('confirmed') }}</label>
              <label v-else class="badge badge-warning">{{ $t('waiting') }}</label>
            </td>
            <td>
              <p>
                <span class="text-gray-999 small">{{ $t('createTime') }}: </span>{{
                  item.createTime | moment('DD/MM/YYYY HH:mm:ss')
                }}
              </p>
              <p v-if="item.registerTime">
                <span class="text-gray-999 small">{{ $t('registerTime') }}: </span>{{
                  item.registerTime | moment('DD/MM/YYYY HH:mm:ss')
                }}
              </p>
              <p v-if="item.confirmTime">
                <span class="text-gray-999 small">{{ $t('confirmTime') }}: </span>{{
                  item.confirmTime | moment('DD/MM/YYYY HH:mm:ss')
                }}
              </p>
              <p v-if="item.denyTime">
                <span class="text-gray-999 small">{{ $t('denyTime') }}: </span>{{
                  item.denyTime | moment('DD/MM/YYYY HH:mm:ss')
                }}
              </p>
            </td>
            <td class="text-right">
              <button @click="del(item._id)" class="btn btn-outline-gray btn-sm is-border-1 mr-1 mb-1"
                      type="button" :disabled="delLoading" v-b-tooltip.hover.top="$t('delete')">
                <i v-if="!delLoading" class="icon12-delete-primary"></i>
                <b-spinner v-else small></b-spinner>
              </button>
              <button @click="resendVerification(item._id)" class="btn btn-outline-gray btn-sm is-border-1 mr-1 mb-1"
                      type="button" :disabled="resendLoading" v-b-tooltip.hover.top="$t('resendVerificationEmail')"
                      v-if="item.registerTime && Date.now() - item.registerTime > 24 * 60 * 60 * 1000 && item.marazId && !item.confirmTime">
                <i v-if="!resendLoading" class="icon12-refesh-primary"></i>
                <b-spinner v-else small></b-spinner>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <b-modal v-model="showForm" :title="$t('addSender')" no-close-on-backdrop no-enforce-focus>
        <p>{{ $t('senderNotice') }}</p>
        <form-input :model="formModel" :errors="formErrors" attribute="email"
                    :placeholder="$t('senderPlaceholder')"></form-input>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="float-right" @click="showForm = false">{{$t('cancel')}}</b-button>
            <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
                <b-spinner v-if="saveLoading" small></b-spinner>
                {{$t('create')}}
            </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import CRUD from "@/mixins/CRUD";
import List from "@/mixins/List";
import console from "console";

export default {
  name: "EmailSender",
  mixins: [CRUD, List],
  data: function () {
    return {
      service: '/email-sender',
      reloadBus: 'loadEmailMarketing',
      resendLoading: false
    };
  },
  methods: {
    resendVerification(id) {
      this.$swal({
        title: this.$t('resendVerification'),
        text: this.$t('resendVerificationAlert'),
        icon: "warning",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.resendLoading = true;
          this.$service.put(`${this.service}/resend-verification/${id}`).then(data => {
            if (data) {
              this.$swal({
                title: this.$t('success'),
                text: this.$t('resendVerificationSuccess'),
                icon: 'success'
              });
            } else {
              this.$swal({
                title: this.$t('fail'),
                text: this.$t('resendVerificationFail'),
                icon: 'warning'
              });
            }
          }).catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
            console.log('Error while resending verification email: ' + error)
          }).finally(() => {
            this.resendLoading = false;
          });
        }
      })
    }
  }
}
</script>